type Props = {
  width: number;
  height: number;
};

const DotIcon = ({ width, height,  }: Props) => (
  <svg
    width={width || 16}
    height={height || 16}
    viewBox={`0 0 ${width} ${height}`}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx={width / 2} cy={height / 2} r={width / 2} />
  </svg>
);

export default DotIcon;
